import PrinterHelper from "../../../../../helpers/PrinterHelper";

export default function LabelItemParagraph({ item, printerData, children }) {
  return (
    <p
      style={{
        fontSize: `${PrinterHelper.getMmToPt(
          item.font_size,
          printerData.dpi
        )}pt`,
        fontWeight: item.font_weight,
        textAlign: item.text_align,
        width: "100%",
        height: "100%",
        textWrap: "wrap",
      }}
    >
      {children}
    </p>
  );
}
